import React from 'react'
import FaIcon from '../../../helpers/fa_icon.js'

const SpotifyStaticPlaylistPreview = ({ url, playlists }) => {
  if(!url) {
    return null
  }

  const playlist = playlists.find(p => p.url === url)

  if(!playlist) {
    return (
      <FaIcon icon="exclamation-circle" text="Playlist not found or unable to load" />
    )
  }

  if(playlist.tracks.length === 0) {
    return (
      <FaIcon icon="exclamation-circle" text="No songs found in this playlist." />
    )
  }

  return (
    <div className="spotify-container">
      <h3>{playlist.playlistName}</h3>
      <table className="table table-striped">
        <thead> 
          <tr>    
            <th>Track</th>
            <th>Artist</th>
            <th>Album</th>    
          </tr>
        </thead>
        <tbody>
          {playlist.tracks.map((track, index) => (
            <tr key={index}>
              <td className="ph-3 font-weight-bold">
                { track.trackName }
              </td>
              <td className="ph-3">
                { track.artistName }
              </td>
              <td className="ph-3">
                { track.albumName }
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

const styles = {
  imagePreview: {
    maxHeight: 60,
    width: 'auto',
    maxWidth: '100%',
  }
}



export default SpotifyStaticPlaylistPreview


